import { createReducer, on, Action } from '@ngrx/store';
import { IUserState, initialUserState } from './user.state';
import * as UserActions from './user.actions';

const userReducerInternal = createReducer(
  initialUserState,
  on(UserActions.loadUserSuccess, (state, { userData }) => ({
    ...state,
    userData,
    apiState: 'Success' as const,
  })),
  on(UserActions.loadUserError, (state, { error }) => ({
    ...state,
    userData: null,
    apiState: 'Failed' as const,
  }))
);

export function userReducer(state: IUserState | undefined, action: Action): IUserState {
  return userReducerInternal(state, action);
}
